<template>
  <div>
    <LmListV2
      ref='LmUsersListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Usuarios',
      gqlField: 'Users',
      gqlVariables: {
        q: '( userType : internal )',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[UsersESSortEnum]) {
        Users(
            titleList: "Listado de Usuarios"
            q: $q
            perPage: 10
            page: $page
            sort: $sort
            metaSearch: "*"
            opts: {
                lenient: true
            }
            lmPathActions: [{to:"/users/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"},{to:"/users/password/:_id",tooltip:"Contraseña",fontAwesomeIcon:"key"}]
            lmModalActions: []
            buttonLinks: [{value:"Nuevo",to:"/users/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info",buttonColor:"#17a2b8",enableOnSelectedRows:false,type:"redirect",requestEndpoint:"",requestConfirmation:false}]
            ) {
            count
            searcher
            tableItemsTotal
            titleList
            filter {
                aggregatesToSelect
            }
            table {
                items {
                    profilePicture,firstname,lastname,email,deleted,role,actions
                }
                fields {
                    key
                    label
                    sortable
                }
            }
            buttons
            pagination
        }
    }`,
      searchOnFieldsSelected: [
        'firstname',
        'lastname',
        'email',
        'role',
        'userType',
        'area',
        'subarea',
        'createdAt',
        'updatedAt',
        'createdBy',
        'updatedBy',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'firstname',
        'lastname',
        'email',
        'role',
        'userType',
        'area',
        'subarea',
        'createdAt',
        'updatedAt',
        'createdBy',
        'updatedBy',
        'actions'
      ],
      items: [
        {
          name: 'firstname'
        },
        {
          name: 'lastname'
        },
        {
          name: 'email'
        },
        {
          name: 'dni'
        },
        {
          name: 'role'
        },
        {
          name: 'userType'
        },
        {
          name: 'area'
        },
        {
          name: 'subarea'
        },
        {
          description: 'Borrado',
          name: 'deleted'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        },
        {
          name: 'actions'
        },
        {
          name: 'profilePicture'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [{
        key: 'profilePicture',
        label: 'Foto',
        sortable: false
      }, {
        key: 'firstname',
        label: 'Nombre',
        sortable: false
      }, {
        key: 'lastname',
        label: 'Apellido',
        sortable: false
      }, {
        key: 'email',
        label: 'Email',
        sortable: false
      }, {
        key: 'deleted',
        label: 'Borrado',
        sortable: false
      }, {
        key: 'role',
        label: 'Rol',
        sortable: true
      }, {
        key: 'actions',
        label: 'Acciones',
        sortable: false
      }]
    }
  }
}
</script>
